import { basenames, appBaseName } from 'config/basenames';

export const BUILD_ID = process.env.REACT_APP_BUILD_ID || '';
export const IFRAME_MODE_MIN_HEIGHT = 400;
export const NEW_IFRAME_MODE_MIN_HEIGHT = 600;
export const APP_RUNNING_ENV = process.env.REACT_APP_RUNNING_ENV || 'prod';
export const IS_LOCAL_DEV = process.env.NODE_ENV === 'development';
export const IS_LIVE_PROD = APP_RUNNING_ENV === 'prod' && !IS_LOCAL_DEV;
export const IS_DEV = APP_RUNNING_ENV === 'dev';
export const IS_IFRAME_MODE = window.self !== window.top;
export const IS_EDITOR_MODE = /\/promotions\/\d+\/\d+\/edit(?:\/)?/i.test(window.location.pathname);
export const IS_UGC_FLOW = appBaseName === basenames.ugc;
export const IS_POINT_FLOW = appBaseName === basenames.point;
export const IS_ACHIEVEMENT_FLOW = appBaseName === basenames.achievement;
export const IS_PROMO_FLOW = appBaseName === basenames.promotions;
export const GLOBAL_LIFF_ID = IS_LIVE_PROD ? '1654689974-YnaByKaZ' : '1608309930-D00eq7P7';
export const SENTRY_REACT_DSN =
    process.env.REACT_APP_SENTRY_REACT_DSN || 'https://6435505397a300484ccafa330b509f9a@o512271.ingest.sentry.io/5611931';
export const SENTRY_TRACES_SAMPLE_RATE =
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ||
    '0.00001';

export const POWER_BY_HEIGHT = 32;
export const IMG_UPLOAD_API_PATH = '/services/images';
export const GAME_FILE_UPLOAD_API_PATH = '/services/sponsors/:sponsorId/game-file/upload';

export const FROALA_V2_KEY =
    process.env.REACT_APP_FROALA_V2_KEY_GENERAL || 'fB4F3E3F2E2D2C5zA3B2A1G3F4F1I1A10B1D6mc1VYJZa1c2a1THYBUZY==';

export const FROALA_KEY =
    process.env.REACT_APP_FROALA_V4_KEY_GENERAL || 'fIE3A-9C2I2I2C6B3C4C2ud1BI1IMNBUMRWAi1AYMSTRBUZYB-16D4E3D2D1C3H2D1B10C2B1==';
export const TURNSTILE_SITE_KEY =
    process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAACKm_DetEGOREqUV';
export const EDITOR_WINDOW_ORIGIN = process.env.REACT_APP_EDITOR_FEVER_HOST
    ? `https://${process.env.REACT_APP_EDITOR_FEVER_HOST}`
    : window.location.origin;
export const EDITOR_API_FEVER_HOST =
    process.env.REACT_APP_EDITOR_FEVER_HOST || window.location.host;
export const CLIENT_API_FEVER_HOST =
    process.env.REACT_APP_CLIENT_FEVER_HOST || window.location.host;
export const INTERCOM_SECRET_KEY =
    process.env.REACT_APP_INTERCOM_SECRET_KEY || 'xdsqVb3gLQtypbClG8EZFFSh4Mx_PRTcHLTQT073';
export const MOCK_API_ENDPOINT = 'http://localhost:3002';

export const {
    FEVER_API_ENDPOINT,
    ZINES_API_ENDPOINT,
    FEVER_LOGIN_API_ENDPOINT,
    SDK_ENV_SUFFIX_BY_ENV,
    IMG_PROXY_PATH,
    THIRD_PARTY_AUTH_ENDPOINT,
    AI_CODE_ENDPOINT,
    AI_CODE_BG_ENDPOINT,
    TURNSTILE_PROXY_URL
} = (runningEnv => {
    switch (runningEnv) {
        case 'prod':
            return {
                FEVER_API_ENDPOINT: 'https://api.feversocial.com',
                ZINES_API_ENDPOINT: 'https://api.feversocial.com/zines',
                FEVER_LOGIN_API_ENDPOINT: 'https://feversocial.com',
                SDK_ENV_SUFFIX_BY_ENV: '',
                IMG_PROXY_PATH: `https://image.fevercdn.com`,
                THIRD_PARTY_AUTH_ENDPOINT: 'https://feversocial.com',
                AI_CODE_ENDPOINT: 'https://assets.fevercdn.com/promotion/production/AI-Code',
                AI_CODE_BG_ENDPOINT: 'https://assets.fevercdn.com/promotion/production/AI-Code',
                TURNSTILE_PROXY_URL: 'https://game-proxy.fevercdn.com'
            };
        case 'dev':
        default:
            return {
                FEVER_API_ENDPOINT: 'https://api.dev.feversocial.com',
                ZINES_API_ENDPOINT: 'https://api.dev.feversocial.com/zines',
                FEVER_LOGIN_API_ENDPOINT: 'https://dev.feversocial.com',
                SDK_ENV_SUFFIX_BY_ENV: '-dev',
                IMG_PROXY_PATH: `https://image.fevercdn.com/dev`,
                THIRD_PARTY_AUTH_ENDPOINT: 'https://dev.feversocial.com',
                AI_CODE_ENDPOINT: IS_LOCAL_DEV
                    ? IS_EDITOR_MODE
                        ? '/games/ai-web-game'
                        : '/games/ai-web-game/obfuscated'
                    : 'https://assets.fevercdn.com/promotion/development/AI-Code',
                AI_CODE_BG_ENDPOINT: 'https://assets.fevercdn.com/promotion/development/AI-Code',
                TURNSTILE_PROXY_URL: 'https://dev-game-proxy.fevercdn.com'
            };
    }
})(APP_RUNNING_ENV);
